/**
 * The one line under a container's master config: whose master config it
 * is, or what to do when the container is not on its group's one — pure,
 * so every case reads the same in the editor and in its spec.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenMasterSummary } from '@trafficpulse/shared';

export interface MasterNote {
  tone: 'muted' | 'warning';
  text: string;
  action?: { label: string; master: DropGenMasterSummary };
}

interface NoteGroup {
  key: string | null;
  label: string;
  master: DropGenMasterSummary | null;
}

export function masterNote(followed: DropGenMasterSummary | null, group: NoteGroup): MasterNote {
  if (group.key === null)
    return { tone: 'warning', text: "Open a campaign group first — a new container follows its group's master config." };
  const own = group.master;
  if (followed && own?.id === followed.id) return { tone: 'muted', text: `the master config of ${group.label}` };
  if (followed && own)
    return { tone: 'warning', text: `the group's master config is ${own.name}`, action: { label: `Switch to ${own.name}`, master: own } };
  if (followed) return { tone: 'warning', text: `${group.label} has no master config yet — this container still follows ${followed.name}` };
  if (own) return { tone: 'muted', text: "not on its group's master config yet", action: { label: `Follow ${own.name}`, master: own } };
  return { tone: 'muted', text: `${group.label} has no master config yet — create it from the containers card` };
}
